import { createSlice } from '@reduxjs/toolkit';
import FILTER_CONSTANTS from '../../constants/FilterConstants';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

const BASE_FILTER_FIELDS = {
  searchText: '',
};

const initialState = {
  open: {
    ...FILTER_CONSTANTS.FILTER_DATA.MONTHLY_OPEN.INITIAL_PARAMS,
    ...BASE_FILTER_FIELDS,
  },
  finalized: {
    ...FILTER_CONSTANTS.FILTER_DATA.MONTHLY_FINALIZED.INITIAL_PARAMS,
    ...BASE_FILTER_FIELDS,
    pageNumber: DEFAULT_PAGE,
    rowsPerPage: DEFAULT_PER_PAGE,
    sort: 'updatedAt:DESC',
  },
};

export const monthlyReconciliationFilterSlice = createSlice({
  name: 'monthlyReconciliationFilterSlice',
  initialState,
  reducers: {
    setOpenFilters(state, action) {
      state.open = {
        ...state.open,
        ...action.payload,
      };
    },
    setFinalizedFilters(state, action) {
      state.finalized = {
        ...state.finalized,
        ...action.payload,
      };
    },
    resetOpenFilters(state) {
      state.open = {
        ...initialState.open,
        searchText: state.open.searchText,
      };
    },
    resetFinalizedFilters(state) {
      state.finalized = {
        ...initialState.finalized,
        searchText: state.finalized.searchText,
      };
    },
    resetState(state) {
      Object.assign(state, initialState);
    },
  },
});

export default monthlyReconciliationFilterSlice;
